export const checkspecialfont = (specialfont: string) => {
  if (specialfont) {
    if (specialfont.charAt(0) === "-" || specialfont.charAt(0) === "+" || specialfont.charAt(0) === "=") {
      return specialfont.substring(1);
    } else {
      return specialfont;
    }
  } else {
    return "";
  }
};
export const checknumberformat = (event: number | string) => {
  const res = Number(event).toFixed(2);
  if (res) {
    let formattedNumber = res.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formattedNumber;
  }
};
export const checknumberformatnodecimal = (event: number | string) => {
  const res = Number(event);
  if (res) {
    let formattedNumber = res.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formattedNumber;
  }
};
